
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ad-dashboard-instream',
	templateUrl: './ad-dashboard-instream.component.html',
	styleUrls: ['./ad-dashboard-instream.component.scss']
})

export class AdDashboardInstreamComponent implements OnInit {

	ngOnInit(): void {
		//
	}
}
